import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { getStaffs } from "actions/teamActions";
import { getProductSchedule, deleteProductSchedule, reUploadProductSchedule } from "actions/productScheduleActions";
import { ReactTable } from "components/Table";
import { ListDateType } from "helper/constant";
import {
    formatterCreateAt,
    convertTZ,
    subStringText,
    FormatterStatus,
} from "components/Function";
import SelectBox from "components/elements/selectBox";
import Loading from "components/Loading";
import cx from "classnames";

const ProductSchedule = ({
    getProductSchedule,
    formatterCreateAt,
    getStaffs,
    subStringText,
    FormatterStatus,
    productSchedule,
    deleteProductSchedule,
    reUploadProductSchedule
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("today");
    const [products_selected, setProductsSelected] = useState([]);
    const [filter, setFilter] = useState({});
    const [staffs, setStaffs] = useState([]);
    const [shops, setShops] = useState([]);
    const [loadingSync, setLoadingSync] = useState(true);
    const [tab, setTab] = useState("products_all");

    const { t } = useTranslation();
    const { list, totalsize, isLoading, list_shop } = productSchedule;
    const listshop = list_shop?.map((v, i) => {
        return { label: `${v?.name} (${v?.note}) - ${v?.region}`, value: v?._id };
    });

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "20",
            value: 20,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "All",
            value: totalsize || 50,
        },
    ];

    const onChangeShop = (e) => {
        var shops_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            shops: shops_tmp || [],
        }));
        setShops(shops_tmp);
    };

    useEffect(() => {
        if (Object.keys(filter).length) {
            getProductSchedule({ page, sizeperpage: sizePerPage, search: searchText, filter });
        }
    }, [getProductSchedule, page, sizePerPage, searchText, filter]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        getStaffs({ sizeperpage: 100 }).then((data) => {
            setStaffs(data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email })) || []);
        });
    }, [getStaffs]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "main_images",
            text: t("Main Images"),
            sort: true,
            headerStyle: { width: "100px" },
            formatter: (cell, row) => (
                <>
                    <div className="symbol symbol-50px">
                        <img src={cell || require("components/assets/media/misc/image.png")} alt="" />
                    </div>
                </>
            ),
        },
        {
            dataField: "title",
            text: t("Title"),
            sort: true,
            headerStyle: { width: "650px" },
            formatter: (cell, row) => <>
                <Link
                    to={`/admin/products/edit/${row.sourceID}`}
                    target="_blank"
                >
                    {subStringText(cell, 80)}
                </Link>

            </>,
        },
        {
            dataField: "status",
            text: t("Status"),
            sort: true,
            formatter: (cell, row) => <FormatterStatus status={cell} />,
        },
        {
            dataField: "message",
            text: t("Message"),
            sort: true,
        },
        {
            dataField: "shops",
            text: t("Shop"),
            sort: true,
            formatter: (cell, row) => `${cell?.name} (${cell?.note}) - ${cell?.region}`,
        },
        {
            dataField: "shopId",
            text: t("Shop ID"),
            sort: true,
            headerClasses: "d-none",
            classes: "d-none",
            formatter: (cell, row) => `${cell?.name} (${cell?.region})`,
        },
        {
            dataField: "create_time",
            text: t("Create Time"),
            sort: true,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
        {
            dataField: "uploaded_time",
            text: t("Uploaded Time"),
            sort: true,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
        {
            dataField: "createdBy",
            text: t("Created By"),
            sort: true,
            formatter: (cell, row) => staffs?.find((v, i) => v?.value === cell)?.label,
        },
        {
            dataField: "-",
            text: t("Actions"),
            formatter: (cell, row, rowIndex, formatExtraData) => (
                <>
                    {/* <Link
                        role="button"
                        to="#"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Change Time")}
                    >
                        <i className="ki-outline ki-notepad-edit fs-2"></i>
                    </Link> */}
                </>
            ),
        },
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const handleFilter = (e) => {
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const onClickDeleteProduct = () => {
        deleteProductSchedule(products_selected).then((data) => {
            return getProductSchedule({ page, sizeperpage: sizePerPage, search: searchText, filter });
        });
    };

    const onClickReUploadProduct = () => {
        reUploadProductSchedule(products_selected).then((data) => {
            return getProductSchedule({ page, sizeperpage: sizePerPage, search: searchText, filter });
        });
    };

    const onClick = (data) => {
        setTab(data);
        if (data === "products_all") {
            setFilter((prev) => ({ ...prev, status: "" }));
        }
        if (data === "products_pending") {
            setFilter((prev) => ({ ...prev, status: "PENDING" }));
        }
        if (data === "products_uploading") {
            setFilter((prev) => ({ ...prev, status: "UPLOADING" }));
        }
        if (data === "products_uploaded") {
            setFilter((prev) => ({ ...prev, status: "UPLOADED" }));
        }
        if (data === "products_failed") {
            setFilter((prev) => ({ ...prev, status: "FAILED" }));
        }
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelect = (row, isSelect) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp.push(row._id);
        } else {
            products_selected_tmp = removeSelect(products_selected_tmp, row._id);
        }
        var new_arr = JSON.stringify(products_selected_tmp);
        setProductsSelected(JSON.parse(new_arr));
        if (products_selected_tmp.length !== 0) {
            setLoadingSync(false);
        }
        if (products_selected_tmp.length === 0) {
            setLoadingSync(true);
        }
    };

    const onSelectAll = (isSelect, row) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp = row.map((v, i) => v._id);
        } else {
            products_selected_tmp = [];
        }
        setProductsSelected(products_selected_tmp);
        if (products_selected_tmp.length !== 0) {
            setLoadingSync(false);
        }
        if (products_selected_tmp.length === 0) {
            setLoadingSync(true);
        }
    };

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: products_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({products_selected.length})</span>
            </div>
        ),
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5 d-flex flex-md-row flex-column gap-2">
                    <button
                        onClick={() => {
                            onClickDeleteProduct();
                        }}
                        disabled={loadingSync}
                        type="button"
                        className="btn btn-danger btn-sm"
                    >
                        <i className="ki-outline ki-cross-circle fs-2"></i> {t("Delete Product Select")}
                    </button>
                    <button
                        disabled={loadingSync}
                        onClick={() => {
                        }}
                        type="button"
                        className="btn btn-warning btn-sm"
                    >
                        <i className="ki-outline ki-shield-tick fs-2"></i> {t("Change Time")}
                    </button>
                    <button
                        disabled={loadingSync}
                        onClick={() => {
                            onClickReUploadProduct();
                        }}
                        type="button"
                        className="btn btn-primary btn-sm"
                    >
                        <i className="ki-outline ki-up fs-2"></i> {t("ReUpload")}
                    </button>
                </div>
                <div className="mb-5 d-flex flex-md-row flex-column justify-content-start w-100 gap-3">
                    <Select
                        isClearable
                        isMulti
                        name="shop"
                        options={listshop}
                        className="cotik-select-virtual"
                        classNamePrefix="select"
                        value={listshop.filter(({ value }) => shops.includes(value))}
                        onChange={(e) => {
                            onChangeShop(e);
                        }}
                        placeholder={t("Select a shop ... ")}
                        theme={(theme) => ({
                            ...theme,
                            spacing: {
                                ...theme.spacing,
                                controlHeight: "100%",
                                controlWidth: "200px",
                            },
                        })}
                    />
                    <select
                        className="form-select basic-multi-select al-custom-select-search-variants al-filter-table"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="currency"
                        name="status"
                        onChange={handleFilter}
                    >
                        <option value="">ALL</option>
                        <option value="PENDING">PENDING</option>
                        <option value="UPLOADING">UPLOADING</option>
                        <option value="UPLOADED">UPLOADED</option>
                        <option value="FAILED">FAILED</option>
                    </select>
                    <SelectBox
                        className="me-2"
                        options={staffs}
                        name="filter_staff"
                        value={filter.staff || ""}
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                staff: data.value || "",
                            }));
                            setPage(1);
                        }}
                    />
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="al-select"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <div className="card">
                <div className="card-body pt-0 pb-0">
                    <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "products_all" })} to="/admin/product-schedule" onClick={(e) => { onClick("products_all"); }}>
                                {t("ALL")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "products_pending" })} to="/admin/product-schedule" onClick={(e) => { onClick("products_pending"); }}>
                                {t("PENDING")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "products_uploading" })} to="/admin/product-schedule" onClick={(e) => { onClick("products_uploading"); }}>
                                {t("UPLOADING")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "products_uploaded" })} to="/admin/product-schedule" onClick={(e) => { onClick("products_uploaded"); }}>
                                {t("UPLOADED")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "products_failed" })} to="/admin/product-schedule" onClick={(e) => { onClick("products_failed"); }}>
                                {t("FAILED")}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card min-w-full">
                <Loading isLoading={isLoading} />
                <div className="card-body">
                    <div className="al-variants-table al-max-height-table-cus">
                        <ReactTable
                            columns={columns}
                            data={list || []}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit"
                            sizePerPageList={sizePerPageList}
                            isSelectRow={true}
                            selectRow={selectRow}
                        />
                    </div>
                </div>
            </div>
        </>

    );
};

const mapStateToProps = ({ productSchedule }) => ({ productSchedule });
const mapDispatchToProps = {
    getProductSchedule,
    formatterCreateAt,
    getStaffs,
    subStringText,
    FormatterStatus,
    deleteProductSchedule,
    reUploadProductSchedule,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSchedule);
